// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_NotificacoesPortalResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /clientes/notificacoes-portal/{cliente_id}
 *
 * Staff-side history of portal messages for one customer, newest first,
 * paginated. Source is the local `cliente_notifications` table — a row exists
 * only when the portal accepted the message, so this list never shows sends
 * that failed.
 */
import type { Clientes_NotificacaoPortalRow } from './Clientes_NotificacaoPortalRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Clientes_NotificacoesPortalResponseDados {
rows: Clientes_NotificacaoPortalRow[]
total: number
page: number
per_page: number
}

export type Clientes_NotificacoesPortalResponse = ApiResponse<Clientes_NotificacoesPortalResponseDados>;

registerResponseContract('Clientes_NotificacoesPortalResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      cliente_notification_id:         { type: 'number',  required: true },
      cliente_notification_cliente_id: { type: 'number',  required: true },
      cliente_notification_body:       { type: 'string',  required: true },
      cliente_notification_sent_by:    { type: 'string',  required: true },
      sent_by_name:                    { type: 'string',  required: false },
      cliente_notification_portal_id:  { type: 'string',  required: false },
      cliente_notification_state:      { type: 'string',  required: false },
      cliente_notification_warning:    { type: 'string',  required: false },
      cliente_notification_created_at: { type: 'string',  required: true },
    },
  },
  total:    { type: 'number',  required: true },
  page:     { type: 'number',  required: true },
  per_page: { type: 'number',  required: true },
})
